module.exports = __webpack_public_path__ + "img/20200613_094108.174102b8.jpg";